module.exports = __webpack_public_path__ + "img/object_utilyg.995dd2e6.svg";